const KeyPerformanceIndicators = {
  Performance: "Performance",
  Cost: "Cost",
  Schedule: "Schedule",
  Risk: "Risk",
  Savings: "Savings",
};

export default KeyPerformanceIndicators;
